// extracted by mini-css-extract-plugin
export default {"agency__requisite":"RequisiteAgency_agency__requisite__4PKXr","agency__requisite__inner":"RequisiteAgency_agency__requisite__inner__iGxXi"};